/**
 * This is the main implementation of the navigation component, only
 * missing the bits that require MooTools for implementation (those
 * are implemented in `./navigation` and passed into this component as
 * props.
 */
import { _js } from '@ifixit/localize';
import { Box, ButtonGroup, Button, Flex, Heading, Link } from '@chakra-ui/react';
import PrettyTabs from 'Chakra/Tabs';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import trackInPiwikAndGA from 'Shared/Analytics/CombinedGAPiwik';

function redirect(where: any) {
   const url = new URL(window.location.toString());
   url.pathname = where;
   url.search = '';
   window.location.href = url.toString();
}

export function Navigation({ links, pageTitle, onIfixit, isLoggedIn }: any) {
   const visibleTabs = links.tabLinks.filter((tab: any) => tab.showTab);

   function getActiveTabIndex() {
      let index = 0;
      while (index < visibleTabs.length) {
         const tab = visibleTabs[index];
         if (tab.label === pageTitle) {
            break;
         }
         index++;
      }
      return index;
   }

   const tabsDataWithHandlers = visibleTabs.map((tabObject: any) => ({
      ...tabObject,
      handler: () => redirect(tabObject.url),
   }));

   const activeTabIndex = getActiveTabIndex();
   const currentTabData = visibleTabs[activeTabIndex];

   return (
      <Box id="communityNav" marginTop={5}>
         <PrettyTabs activeTab={activeTabIndex} tabsData={tabsDataWithHandlers} fitted={true} />
         <Flex
            as="header"
            flexWrap="wrap"
            justifyContent={{ base: 'center', md: 'space-between' }}
            alignItems="center"
            marginTop={4}
         >
            <Heading
               as="h1"
               color="gray.800"
               margin={{ base: '0 0 6px 0', md: '0 0 0 0' }}
               fontSize="30px"
               fontWeight="medium"
               fontStyle="normal"
               width={{ base: '100%', md: 'auto' }}
            >
               {pageTitle}
            </Heading>
            <ButtonGroup
               display={{ base: 'none', md: 'flex' }}
               flexWrap={'wrap'}
               justifyContent="end"
               flex="auto"
               spacing={{ base: 2, md: 4 }}
            >
               {onIfixit && (
                  <Button
                     as={Link}
                     variant="ghost"
                     href={currentTabData?.help}
                     onClick={() => {
                        trackInPiwikAndGA({
                           eventCategory: pageTitle,
                           eventAction: `${pageTitle} - Btn "How this Works"`,
                           eventName: currentTabData?.help,
                        });
                     }}
                  >
                     {_js('How this Works')}
                     <Box as="span" marginLeft={2}>
                        <FontAwesomeIcon icon={faCircleInfo} />
                     </Box>
                  </Button>
               )}
               {!isLoggedIn && (
                  <Link
                     href="/Join"
                     onClick={() => {
                        trackInPiwikAndGA({
                           eventCategory: pageTitle,
                           eventAction: `${pageTitle} - Btn - Join`,
                        });
                     }}
                  >
                     <Button variant="cta">{_js('Join')}</Button>
                  </Link>
               )}
            </ButtonGroup>
         </Flex>
      </Box>
   );
}
